import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  height: 100%;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 60px 0 60px 0;
`;
